<template>
	<footer class="app-footer">
        <span>&copy; 2018 <a href="https://dialogera.com/" target="_blank">Dialogera</a> Labs.</span>
	</footer>
</template>
<script>
export default {
	name: 'c-footer',
}
</script>
